/**
 * LMG Cross-sell — al abrir la cart-notification, fetcha recommendations
 * del producto recien agregado y muestra mini-grid de 3 sugerencias.
 *
 * Triggers cuando la cart-notification se hace visible (MutationObserver
 * sobre #cart-notification.active class o display style).
 */
(function () {
  var notif = document.querySelector('#cart-notification');
  var box = document.querySelector('[data-lmg-crosssell]');
  var grid = document.querySelector('[data-lmg-crosssell-grid]');
  if (!notif || !box || !grid) return;

  function money(cents) {
    return '$' + ((cents || 0) / 100).toLocaleString('es-CO', { maximumFractionDigits: 0 });
  }

  var lastFetchedFor = null;

  // Free shipping progress bar
  var shipBox = document.querySelector('[data-lmg-ship-progress]');
  var shipText = document.querySelector('[data-lmg-ship-text]');
  var shipFill = document.querySelector('[data-lmg-ship-fill]');
  var SHIP_THRESHOLD_CENTS = shipBox ? parseInt(shipBox.getAttribute('data-threshold'), 10) * 100 : 15000000;

  function updateShipping(cartTotalCents) {
    if (!shipBox) return;
    var remaining = SHIP_THRESHOLD_CENTS - cartTotalCents;
    var pct = Math.min(100, Math.max(0, (cartTotalCents / SHIP_THRESHOLD_CENTS) * 100));
    shipFill.style.width = pct + '%';
    if (remaining <= 0) {
      shipBox.classList.add('lmg-ship-progress--reached');
      shipText.innerHTML = '<strong>¡Felicidades!</strong> Tu pedido tiene envío gratis';
    } else {
      shipBox.classList.remove('lmg-ship-progress--reached');
      var remCop = '$' + (remaining / 100).toLocaleString('es-CO', { maximumFractionDigits: 0 });
      shipText.innerHTML = 'Te faltan <strong>' + remCop + '</strong> para envío gratis';
    }
    shipBox.removeAttribute('hidden');
  }

  function fetchRecs() {
    // Get the just-added product id from cart-notification product link or fetch cart
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update shipping progress always (even if empty)
        updateShipping(cart.total_price || 0);

        if (!cart.items || cart.items.length === 0) return;
        // Use the LAST added item (top of items array in Shopify cart)
        var lastItem = cart.items[0];
        var productId = lastItem.product_id;
        if (productId === lastFetchedFor) return;
        lastFetchedFor = productId;

        return fetch('/recommendations/products.json?product_id=' + productId + '&limit=3&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!data.products || data.products.length === 0) {
              box.setAttribute('hidden', '');
              return;
            }
            grid.textContent = '';
            data.products.forEach(function (p) {
              var card = document.createElement('a');
              card.className = 'lmg-crosssell__card';
              card.href = '/products/' + encodeURIComponent(p.handle || '');
              var imgSrc = (p.featured_image && (p.featured_image.url || p.featured_image)) ||
                           (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';

              var imgEl = document.createElement('img');
              imgEl.className = 'lmg-crosssell__card-img';
              imgEl.src = imgSrc;
              imgEl.alt = p.title || '';
              imgEl.loading = 'lazy';

              var titleEl = document.createElement('h4');
              titleEl.className = 'lmg-crosssell__card-title';
              titleEl.textContent = p.title || '';

              var priceEl = document.createElement('p');
              priceEl.className = 'lmg-crosssell__card-price';
              priceEl.textContent = money(p.price);

              card.appendChild(imgEl);
              card.appendChild(titleEl);
              card.appendChild(priceEl);
              grid.appendChild(card);
            });
            box.removeAttribute('hidden');
          });
      })
      .catch(function () {});
  }

  // Watch for notification opening
  // The Shopify CartNotification component adds the class via JS show()/hide()
  // We watch for the dialog becoming visible (display change or active class)
  var observer = new MutationObserver(function () {
    if (notif.classList.contains('active') || getComputedStyle(notif).display !== 'none') {
      fetchRecs();
    }
  });
  observer.observe(notif, { attributes: true, attributeFilter: ['class', 'style'] });

  // Also hook into cart:item-added events from Shopify if dispatched
  document.addEventListener('cart-notification:show', fetchRecs);
})();
